import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcstaff/staffloginpage/TeacherLoginPage.css";

const BookIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="#ffffff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TeacherResetPasswordPage = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const email = searchParams.get("email");

  const [cardIn, setCardIn] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [linkInvalid, setLinkInvalid] = useState(false);

  useEffect(() => { setTimeout(() => setCardIn(true), 60); }, []);

  useEffect(() => {
    if (!token || !email) {
      setLinkInvalid(true);
    }
  }, [token, email]);

const handleSubmit = (e) => {
  e.preventDefault();
  setError("");

  if (!newPassword || !confirmPassword) {
    setError("Please fill in both fields.");
    return;
  }

  if (newPassword.length < 6) {
    setError("Password must be at least 6 characters long.");
    return;
  }

  if (newPassword !== confirmPassword) {
    setError("Passwords do not match.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/teacher/auth/resetPassword`, {
    email: email,
    token: token,
    new_password: newPassword
  })
  .then((res) => {
    if (res.data.success) {
      setDone(true);
    } else {
      setError(
        res.data.message ||
        res.data.error ||
        "Something went wrong. Please try again."
      );
    }
  })
  .catch((err) => {
    setError(
      err.response?.data?.message ||
      err.response?.data?.error ||
      "Something went wrong. Please try again."
    );
  })
  .finally(() => {
    setLoading(false);
  });
  };

  return (
    <div className="gcStaff-auth-bg">
      <div className={`gcStaff-auth-card ${cardIn ? "gcStaff-auth-card--in" : ""}`}>

        <div className="gcStaff-auth-logo">
          <BookIcon />
        </div>

        {linkInvalid ? (
          <div className="gcStaff-auth-success">
            <h3 className="gcStaff-auth-success-title">Invalid Link</h3>
            <p className="gcStaff-auth-success-msg">
              This password reset link is invalid or incomplete. Please request a new one.
            </p>
            <button
              className="gcStaff-auth-btn"
              onClick={() => navigate("/teacher/forgot-password")}
            >
              Request New Link
            </button>
          </div>
        ) : !done ? (
          <>
            <h2 className="gcStaff-auth-title">Reset Password</h2>
            <p className="gcStaff-auth-sub">Enter your new password below</p>

            {error && <div className="gcStaff-auth-error">{error}</div>}

            <form className="gcStaff-auth-form" onSubmit={handleSubmit} noValidate>
              <input
                className="gcStaff-auth-input"
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                autoComplete="new-password"
              />
              <input
                className="gcStaff-auth-input"
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
              />
              <button
                type="submit"
                className={`gcStaff-auth-btn ${loading ? "gcStaff-auth-btn--loading" : ""}`}
                disabled={loading}
              >
                {loading ? <span className="gcStaff-auth-spinner" /> : "Reset Password"}
              </button>
            </form>
          </>
        ) : (
          <div className="gcStaff-auth-success">
            <div className="gcStaff-auth-success-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#0f8a65" strokeWidth="1.8"/>
                <path d="M8 12l3 3 5-5" stroke="#0f8a65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="gcStaff-auth-success-title">Password Reset!</h3>
            <p className="gcStaff-auth-success-msg">
              Your password has been reset successfully. You can now log in with your new password.
            </p>
            <button
              className="gcStaff-auth-btn"
              onClick={() => navigate("/teacher/login")}
            >
              Go to Login
            </button>
          </div>
        )}

        <button className="gcStaff-auth-back" onClick={() => navigate("/")}>
          ← Back to Home
        </button>

      </div>
    </div>
  );
};

export default TeacherResetPasswordPage;